import { useEffect, useState } from "react";

export const useDetectMacOS = () => {
  const [isMacOS, setIsMacOS] = useState(false);
  const [osLoading, setOsLoading] = useState(true);

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    setIsMacOS(userAgent.includes("mac"));
    setOsLoading(false);
  }, []);

  return { isMacOS, osLoading };
};
